import React, { ReactNode } from 'react';
import styled from 'styled-components';
import useHover from 'shared/hooks/use-hover';
import useClickOut from 'shared/hooks/use-click-out';

type MoreButtonProps = {
  children: ReactNode;
};

export function MoreButton(props: MoreButtonProps): JSX.Element {
  const { children } = props;
  const [hoverRef, isHovered] = useHover();
  const [clickRef, open, setOpen] = useClickOut();

  return (
    <MoreContainer
      ref={hoverRef}
      onClick={(e): void => {
        e.stopPropagation();
        setOpen(!open);
      }}
    >
      <MoreIcon ref={clickRef} src={isHovered || open ? '/icons/more-icon-dark.svg' : '/icons/more-icon.svg'} />
      <Popup open={open}>{children}</Popup>
    </MoreContainer>
  );
}

export const Option = styled.div<{ disabled?: boolean }>`
  background-color: #ffffff;
  font-size: 13px;
  width: 100%;
  height: 43px;
  padding: 0 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;

  &:hover {
    background-color: #f6f6f6;
  }
  &:first-of-type {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &:last-of-type {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    color: #ccc
  `}
`;

export const MoreContainer = styled.div`
  display: flex;
  position: relative;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const MoreIcon = styled.img`
  width: 17px;
`;

export const Popup = styled.div<{ open: boolean; top?: string; right?: string }>`
  width: auto;
  border-radius: 4px;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.11);
  border: solid 1px #d2d5da;
  background-color: #ffffff;
  z-index: 2;
  position: absolute;
  top: ${({ top }) => top ?? '20px'};
  right: ${({ right }) => right ?? '0px'};
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  opacity: ${({ open }) => (open ? '1' : '0')};
`;
